import { web, api } from './axios';
import { Notify, Dialog } from 'quasar';

export const setupInterceptors = () => {
    api.interceptors.response.use(function (response) {
        if (response?.data?.message) {
            Notify.create({
                type: 'positive',
                message: response.data.message,
            });
        }
        return response;
    }, function (error) {
        const responseData = error?.response?.data;

        if (responseData?.message) {
            Notify.create({
                type: 'negative',
                message: responseData.message,
            });
        }
        if (responseData?.errorArr) {
            const {errorArr, message} = responseData
            Dialog.create({
                title: message,
                message: errorArr.join("<br>"),
                html: true,
                persistent: true,
                ok: {
                    label: "Cerrar",
                    color: "negative",
                },
            });
        }

        return Promise.reject(error);
    });

    web.interceptors.response.use(function onFulfilled(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function onRejected(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
}
